import { render } from "./PredictionBatch.vue?vue&type=template&id=1ef25eec&scoped=true&ts=true"
import script from "./PredictionBatch.vue?vue&type=script&lang=ts"
export * from "./PredictionBatch.vue?vue&type=script&lang=ts"

import "./PredictionBatch.vue?vue&type=style&index=0&id=1ef25eec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef25eec"]])

export default __exports__